import { Money }             from '../common/money';
import { supplierCartParts } from './supplierCartParts';

const supplierCartPartsItems = {
  items: supplierCartParts,
};

export { supplierCartPartsItems };